import React from 'react';
import './ToolbarSeparator.scss';

const ToolbarSeparator = React.memo(props => 
    <div className={`co-toolbar-separator ${props.className ? props.className : ""}`}></div>
);

export default ToolbarSeparator;